module.exports = __webpack_public_path__ + "img/like.04a11f94.svg";